<template>
  <div>
    <div
      class="btn-group"
      data-toggle="buttons"
    >
      <label
        v-for="(option,index) in options"
        :key="option.name"
        class="btn btn-primary"
        :disabled="disabled"
        :class="{ active: option.value == currentActiveOption.value }"
      >
        <input
          ref="option.name"
          :disabled="disabled"
          class="btn btn-primary"
          :class="{'disabled': disabled}"
          type="radio"
          autocomplete="off"
          checked
          @click="setToggle(option)"
        >
        {{ option.name }} 
        <template v-if="option.state">
          <span
            v-if="option.state"
            :id="`${toggleName}toggle${index}`"
          >({{ option.state.text }})</span>
          <Tooltip
            :text="setToggleButtonTooltip(option)"
            custom-class="tooltip-black"
            :target="`#${toggleName}toggle${index}`"
          />
        </template>
      </label>
    </div>
    <slot />
  </div>
</template>

<script>
import sharedMessages from '@/core/locales';
import { Tooltip } from 'uiv';
export default {
  name: 'MultipleToggleOverride',
  components: {Tooltip},
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: [Boolean, String, Number],
      default() {
        return null;
      }
    },
    options: {
      type: Array,
      default() {
        return [{
          name: 'Off',
          value: 'Off',
        }];
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    toggleName: {
      type: String,
      default() {
        return 'Default';
      }
    }
  },
  data() { 
    return{
      currentActiveOption: null
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.currentActiveOption = this.options.find(op => op.value === newValue);
        }
      }
    }
  },
  methods: {
    setToggle(newActiveOption) {
      this.currentActiveOption = newActiveOption;

      this.$emit('onToggle', newActiveOption);
      this.$emit('change', newActiveOption);
    },
    setToggleButtonTooltip(option) {
      if (option.state) {
        return `<a href="${option.state.link}" target="_blank">${this.$t('CLICK_TO_EDIT')} <i class="fa fa-edit" /></a>`;
      }
    }
  },
  i18n: {
    sharedMessages,
    locale: 'en'
  },
};
</script>